<template>
  <div>
    <!-- 头部组件 -->
    <div :style="style" class="head">
      <div class="header">
        <div class="title_log">
          <img alt="" src="../../static/title_logo.png" />
        </div>
        <div class="left">
          <!-- <div class="img"><img src="../../static/logo.png" alt="" /></div> -->
          <div class="img" v-if="lang == 'zh'">
            <img alt="" src="../../static/logo1.png" />
          </div>
          <!-- <div class="txt">
            <p class="p1">第二十届中国国际煤炭采矿技术交流及设备展览会</p>
            <p class="p2">China Coal & Mining Expo 2023</p>
            <p class="p3">北京中国国际展览中心（新馆） 2023年10月25-28日</p>
          </div> 1-->
        </div>
        <div
          class="center"
          :style="{
            marginLeft: isLowScreen == true ? (lang == 'en' ? '3px' : '240px') : '6%',
          }"
        >
          <ul>
            <router-link
              class="hyperlinks"
              to="index"
              :style="{
                marginLeft: isLowScreen == true ? (lang == 'en' ? '5px' : '15px') : '36px',
              }"
            >
              <li style="color: #fdd000">{{ $t('navbar.home') }}</li>
            </router-link>
            <router-link
              class="hyperlinks"
              to="exhibition"
              :style="{
                marginLeft: isLowScreen == true ? (lang == 'en' ? '5px' : '15px') : '36px',
              }"
            >
              <li>{{ $t('navbar.exhibition') }}</li>
            </router-link>
            <router-link
              class="hyperlinks"
              to="exhibitsList"
              :style="{
                marginLeft: isLowScreen == true ? (lang == 'en' ? '5px' : '15px') : '36px',
              }"
            >
              <li>{{ $t('navbar.exhibits') }}</li>
            </router-link>
            <router-link
              class="hyperlinks"
              to="live"
              :style="{
                marginLeft: isLowScreen == true ? (lang == 'en' ? '5px' : '15px') : '36px',
              }"
            >
              <li>{{ $t('navbar.live') }}</li>
            </router-link>
            <router-link
              class="hyperlinks"
              to="active"
              :style="{
                marginLeft: isLowScreen == true ? (lang == 'en' ? '5px' : '15px') : '36px',
              }"
            >
              <li>{{ $t('navbar.activity') }}</li>
            </router-link>
            <router-link
              class="hyperlinks"
              to="#"
              :style="{
                marginLeft: isLowScreen == true ? (lang == 'en' ? '5px' : '15px') : '36px',
              }"
            >
              <li class="li">
                {{ $t('navbar.onlineHall') }}
                <div class="menu">
                  <router-link to="#"
                    ><p @click="routerLink('vr')">
                      {{ $t('navbar.VRview') }}
                    </p></router-link
                  >
                  <router-link to="#"
                    ><p @click="routerLink('imgView')">{{ $t('navbar.imgView') }}</p></router-link
                  >
                  <router-link to="#"
                    ><p @click="routerLink('videoView')">{{ $t('navbar.videoView') }}</p></router-link
                  >
                </div>
              </li>
            </router-link>
            <a
              class="hyperlinks"
              :href="hzZhanhui"
              target="_blank"
              :style="{
                marginLeft: isLowScreen == true ? (lang == 'en' ? '5px' : '15px') : '36px',
              }"
              ><li>{{ $t('navbar.onlineWeb') }}</li></a
            >
          </ul>
        </div>
        <div
          class="right"
          :style="{
            marginLeft: isLowScreen == true ? (lang == 'en' ? '1px' : '26px') : '26px',
          }"
        >
          <div
            :class="hasViewToken ? 'login1' : 'login'"
            @click="logins(1)"
            :style="{
              padding: lang == 'zh' ? '0px 17px ' : '0px 3px',
              boxSizing: 'boder-box',
            }"
          >
            {{ hasViewToken ? $t('navbar.audienceCenter') : $t('navbar.audienceLogin') }}
          </div>
          <div
            :class="hasToken ? 'login1' : 'login'"
            @click="logins(2)"
            :style="{
              padding: lang == 'zh' ? '0px 17px ' : '0px 3px',
              boxSizing: 'boder-box',
            }"
          >
            {{ hasToken ? $t('navbar.exhibitionCenter') : $t('navbar.exhibitionLogin') }}
          </div>
          <div
            class="language"
            @click="changeLang()"
            :style="{
              marginLeft: isLowScreen == true ? (lang == 'en' ? '1px' : '3px') : '5px',
            }"
          >
            <div v-if="toggle" class="chese">{{ $t('navbar.zh') }}</div>
            <div v-else class="english">{{ $t('navbar.en') }}</div>
            <!-- <div v-if="toggle" class="chese"><img src="../../static/ico-chinese.png" />{{ $t('navbar.zh') }}</div>
            <div v-else class="english"><img src="../../static/ico-english.png" />{{ $t('navbar.en') }}</div> -->
          </div>
        </div>
      </div>
    </div>

    <!-- lunbo组件 -->
    <LoopImg />

    <div class="bbody">
      <div class="container">
        <!-- 搜索框开始 -->
        <div class="goldBox">
          <div class="title">{{ $t('homePage.quickFind') }}</div>
          <div class="search">
            <!-- 下拉框 -->
            <div class="selectBox">
              <el-select slot="prepend" v-model="select" :placeholder="$t('homePage.placeholder1')"  popper-class="sel">
                <el-option
                  style="height: auto"
                  v-for="(item, index) in category"
                  :key="index"
                  :label="$t('homePage.searchCategory.searchCategory' + item.key)"
                  :value="item.key"
                ></el-option>
              </el-select>
            </div>

            <!-- 下拉选择树 -->
            <div class="selecTree">
              <!-- <el-select v-model="selectLabel" :placeholder="holder" clearable popper-class="tree" @clear="resetTreeData()">
                <el-option :value="treeData" style="height: auto;width: 100%;">
                  <el-tree
                    ref="tree"
                    :check-strictly="true"
                    :data="treeData"
                    :expand-on-click-node="false"
                    :props="defaultProps"
                    default-expand-all
                    highlight-current
                    node-key="id"
                    show-checkbox
                    @node-click="nodeClick"
                    @check-change="checkChange"
                  ></el-tree>
                </el-option>
              </el-select> -->
              <el-cascader :placeholder="holder" :options="keywordsLists" v-model="selectScreen" @change="handleCascader" filterable clearable></el-cascader>
            </div>

            <!-- 搜索框 -->
            <div class="searchBox">
              <el-input v-model="search" :placeholder="$t('homePage.placeholder2')"></el-input>
            </div>
            <!-- 搜索按钮 -->
            <div class="btn">
              <el-button icon="el-icon-search" @click="searchClick()">{{ $t('homePage.search') }}</el-button>
            </div>
          </div>
        </div>
        <!-- 搜索框结束 -->
        <div class="recommended">{{ $t('homePage.productRecommend') }}</div>

        <!--tab滑动面板-->
        <div class="box">
          <!--左侧面板-->
          <div class="left">
            <div v-for="(item, index) in navImg" :key="index" class="leftItem" :class="{ active: hoverActive == index }" @mouseenter="entry(index)">
              <div class="img"><img :src="item.imgUrl" alt="" /></div>
              <div class="titlee" :title="item.label">{{ $t(item.label) }}</div>
            </div>
          </div>

          <!--右侧面板-->
          <div class="right">
            <div v-for="(item, index) in RecommendExhibits" :key="index" class="rightBox" @click="goDetail(item.id)">
              <div class="parameter">
                <div class="titl">{{ item.exhibitsName }}</div>
                <div class="english ellipsis">{{ item.column23 }}</div>
                <div class="txt ellipsis">{{ item.column19 }}</div>
              </div>
              <div class="backImg">
                <img :src="item.exhibitsCoverImg" alt="" />
              </div>
              <div class="companyName">
                <span class="leftTitle">{{ item.companyName  }}</span>
                <span class="rightIcon" @click.stop="consult(item)">
                  <img src="../../static/consulting.png" alt="" />
                  <div class="hoversty">{{ $t('common.consult') }}</div>
                </span>
              </div>
              <div class="boxBottom">
                <span class="bottomTxt"
                  ><a href="#" @click.prevent="goDetail(item.id)">{{ $t('common.more') }}</a></span
                >
                <span class="bottomImg" @click.stop="collection(item, 2)">
                  <img v-if="item.collectStatus" alt="" src="../../static/collent_yello.png" />
                  <!--显示金色-->
                  <img v-else alt="" src="../../static/collen1t.png" /><!--显示无色-->
                  <div class="hoversty">
                    {{ item.collectStatus ? $t('common.clearCollect') : $t('common.collect') }}
                  </div>
                </span>
              </div>
            </div>
          </div>
        </div>

        <!--查看更多-->
        <router-link to="exhibitsList">
          <div class="lookMore">{{ $t('common.viewMore') }}</div>
        </router-link>
      </div>
    </div>

    <!-- vr看景 -->
    <VRSee />

    <!-- 展商推荐 -->
    <Recommend :lang="lang" />

    <!--通栏广告位-->
    <div class="backImg">
      <img alt="" src="../../static/bannerSlotCn.png" v-if="lang == 'zh'" />
      <img src="../../static/advertisementEnglishEn.png" alt="" v-else />
    </div>

    <!-- 展商直播 -->
    <ExhibitorsLive />

    <!-- 精彩活动 -->
    <Activities />

    <!-- 尾部 -->
    <FootBottom />

    <!-----------------------快捷入口-------------------------->
    <!--     <div class="quickEntry">
      <Quick></Quick>
    </div> -->
    <!------------------------------------------------------->
  </div>
</template>

<script>
import HeadTop from '../../common/head.vue'; //头部
import LoopImg from '../../common/loopImg.vue'; //banner轮播图
import VRSee from '../../components/homPage/VRSee.vue'; //VR全景看展
import Recommend from '../../components/homPage/recommend.vue'; //展商推荐
import ExhibitorsLive from '../../components/homPage/exhibitorsLive.vue'; //展商直播
import Activities from '../../components/homPage/activities.vue'; //精彩活动
import FootBottom from '../../common/footBottom.vue'; //尾部
import Quick from '../../Quick.vue'; //快捷入口
import { getrecommendedExhibits, addCollect, getbannerSlot } from '../../../api/homePage';
import { forMat, hzExhibitionLogin, hzAudienceLogin, hzExhibitionIndex, hzAudienceIndex, hzZhanhui, testDomain } from '../../../utils/common';
import * as tools from '../../../utils/roulink';
import products from '../../../Json/screenLists.js';
import productsEn from '../../../Json/searchListsEn.js';
import { collecExhibit } from '../../../api/exhibitProduct';
export default {
  components: {
    HeadTop,
    LoopImg,
    VRSee,
    Recommend,
    ExhibitorsLive,
    Activities,
    FootBottom,
    Quick,
  },
  watch: {
    select: {
      handler: function(newVal, oldVal) {
        if (this.select == '0') {
          this.holder = this.$t('homePage.handle.handle' + this.select);
          // this.treeData = this.searchList;
          // this.resetTreeData();
        } else if (this.select == '1') {
          this.holder = this.$t('homePage.handle.handle' + this.select);
          // this.treeData = this.searchList;
          // this.resetTreeData();
        } else {
          this.holder = this.$t('homePage.placeholder1');
          // this.resetTreeData();
          this.treeData = [];
          this.selectLabel = null;
          this.selectValue = null;
        }
      },
      immediate: true,
      deep: true,
    },
    lang(newVal, oldVal) {
      if (newVal == 'en') {
        this.navImg = [
          {
            imgUrl: require('../../static/mining.png'),
            title: '井下开采',
            label: this.$t('mobileRecommend.UndergroundMining'),
          },
          {
            imgUrl: require('../../static/tunneling.png'),
            title: '井下掘进',
            label: this.$t('mobileRecommend.UndergroundTunneling'),
          },
          {
            imgUrl: require('../../static/transport.png'),
            title: '井下运输',
            label: this.$t('mobileRecommend.UndergroundTransportation'),
          },
          {
            imgUrl: require('../../static/power.png'),
            title: '煤矿机电与动力',
            label: this.$t('mobileRecommend.CoalMineElectromechanicalandPower'),
          },
          {
            imgUrl: require('../../static/proSystem.png'),
            title: '煤矿辅助生产系统',
            label: this.$t('mobileRecommend.CoalMineAuxiliaryProductionSystem'),
          },
          {
            imgUrl: require('../../static/production.png'),
            title: '自动化控制和煤矿智能化',
            label: this.$t('mobileRecommend.SMARTMineAutomation'),
          },
          {
            imgUrl: require('../../static/coal.png'),
            title: '煤炭加工利用',
            label: this.$t('mobileRecommend.CoalProcessingUtilization'),
          },
          {
            imgUrl: require('../../static/openAir.png'),
            title: '露天采矿',
            label: this.$t('mobileRecommend.Open_AirMining'),
          },
          {
            imgUrl: require('../../static/engineering.png'),
            title: '矿山服务与工程',
            label: this.$t('mobileRecommend.CoalMineServicesandEngineering'),
          },
          {
            imgUrl: require('../../static/mineral.png'),
            title: '矿用物资、工具及加工制造',
            label: this.$t('mobileRecommend.MineMaterialInstrumentsandProcessing'),
          },
        ];
      }
    },
  },

  data() {
    return {
      hzZhanhui: hzZhanhui(),
      selectScreen: [],
      keywordsLists: null,
      loginUrl: hzExhibitionLogin(),
      audienceLoginUrl: hzAudienceLogin(),
      hzExhibitionIndex: hzExhibitionIndex(),
      audienceIndex: hzAudienceIndex(),
      testBaseDomain: testDomain(),
      // searchList: null,
      hasToken: false,
      hasViewToken: false,
      test: '',
      isActive: true, //语言
      select: 0,
      holder: '',
      editCheckId: null,
      search: '',
      selec: '',
      selectValue: '',
      selectLabel: [],
      category: [
        { key: 0, val: 0 },
        { key: 1, val: 1 },
      ],
      //树形框相关函数
      mineStatus: '',
      mineStatusValue: [],
      treeData: [],

      defaultProps: {
        children: 'children',
        label: 'label',
      },
      style: {}, // 渐变动态背景

      toggle: false,

      navImg: [
        {
          imgUrl: require('../../static/mining.png'),
          title: '井下开采',
          label: this.$t('mobileRecommend.UndergroundMining'),
        },
        {
          imgUrl: require('../../static/tunneling.png'),
          title: '井下掘进',
          label: this.$t('mobileRecommend.UndergroundTunneling'),
        },
        {
          imgUrl: require('../../static/transport.png'),
          title: '井下运输',
          label: this.$t('mobileRecommend.UndergroundTransportation'),
        },
        {
          imgUrl: require('../../static/power.png'),
          title: '煤矿机电与动力',
          label: this.$t('mobileRecommend.CoalMineElectromechanicalandPower'),
        },
        {
          imgUrl: require('../../static/proSystem.png'),
          title: '煤矿辅助生产系统',
          label: this.$t('mobileRecommend.CoalMineAuxiliaryProductionSystem'),
        },
        {
          imgUrl: require('../../static/production.png'),
          title: '自动化控制和煤矿智能化',
          label: this.$t('mobileRecommend.SMARTMineAutomation'),
        },
        {
          imgUrl: require('../../static/coal.png'),
          title: '煤炭加工利用',
          label: this.$t('mobileRecommend.CoalProcessingUtilization'),
        },
        {
          imgUrl: require('../../static/openAir.png'),
          title: '露天采矿',
          label: this.$t('mobileRecommend.Open_AirMining'),
        },
        {
          imgUrl: require('../../static/engineering.png'),
          title: '矿山服务与工程',
          label: this.$t('mobileRecommend.CoalMineServicesandEngineering'),
        },
        {
          imgUrl: require('../../static/mineral.png'),
          title: '矿用物资、工具及加工制造',
          label: this.$t('mobileRecommend.MineMaterialInstrumentsandProcessing'),
        },
      ],
      //推荐展品
      RecommendExhibits: [],
      dataSource: [],
      Advertisement: '', //广告位
      hoverActive: '0',
      lang: 'zh',
      isLowScreen: false,
    };
    // return 结束
  },

  methods: {
    routerLink(flag) {
      let routerUrl;
      if (flag == 'vr') {
        routerUrl = this.testBaseDomain + 'index?slanguage=' + this.lang;
      }
      if (flag == 'imgView') {
        routerUrl = this.testBaseDomain + 'index?pop=photo&slanguage=' + this.lang;
      }
      if (flag == 'videoView') {
        routerUrl = this.testBaseDomain + 'index?pop=video&slanguage=' + this.lang;
      }
      window.open(routerUrl);
    },

    consult(item) {
      tools.login(1, item.hzExhibitorId);
    },
    logins(val) {
      tools.login(val);
    },

    //收藏or取消收藏 type:1=收藏展商;2=收藏展品;3=收藏直播;4=收藏活动
    async collection(item, type) {
      const willStatus = !item.collectStatus;
      const params = {
        objId: item.id,
        flag: willStatus,
        type: type,
      };
      // const toggleStatus = willStatus === true ? true : false;
      try {
        const { data } = await addCollect(params);
        if (data.code === 200) {
          if (!item.collectStatus && (item.collectStatus = !item.collectStatus)) {
            this.$message({
              showClose: true,
              message: this.$t('common.successCollect'),
              type: 'success',
            });
          } else {
            item.collectStatus = !item.collectStatus;
            this.$message({
              showClose: true,
              message: this.$t('common.cancelCollect'),
              type: 'success',
            });
          }
        } else {
          // this.$message({
          //   showClose: true,
          //   message: data.msg,
          //   type: 'warning',
          // });
          tools.login(3);
        }
      } catch (err) {
        console.log(err);
      }
    },

    //展品推荐跳转展品详情页
    goDetail(id) {
      this.$router.push({
        name: 'exhibItem_detail',
        query: {
          id,
        },
      });
    },

    //根据展品推荐一级分类来调用接口
    setrecommendExhibits() {
      // this.navImg.forEach((item,i)=>{
      //   let params = item.title
      //   this.getrecommendedExhibits(params);
      //   console.log(i)
      // });
      let that = this;
      let alldata = this.navImg.map((item, i) => {
        let params = item.title;
        return this.getrecommendedExhibits(params);
      });
      Promise.all(alldata).then((res) => {
        res.forEach((item, i) => {
          that.dataSource.push({ mining: item });
        });
        // console.log(that.dataSource)
        that.RecommendExhibits = this.dataSource[0].mining;
      });
    },

    async getrecommendedExhibits(params) {
      try {
        let { data } = await getrecommendedExhibits(params);
        let mining = [];
        data.data.list.forEach((item, i) => {
          if(item.exhibitsCoverImg.indexOf("http")  == -1){
            item.exhibitsCoverImg= forMat() +  item.exhibitsCoverImg;
          }
          mining.push({
            id: item.id,
            exhibitsName: item.exhibitsName, //展品名称
            column23: item.column23, //展品型号
            column19: item.column17, //一级分类
            exhibitsCoverImg: item.exhibitsCoverImg, //封面地址
            companyName: this.lang == 'zh' ? item.hzExhibitor.companyNameC : item.hzExhibitor.companyNameE, //公司名称中文
            collectStatus: item.collectStatus, //0=未收藏；1=已收藏
            hzExhibitorId: item.hzExhibitorId,
          });
        });
        return mining;
        // this.dataSource.push({mining});
        // console.log(params)
        // console.log(mining)
      } catch (e) {
        console.log(e);
      }
    },

    //展品推荐左侧切换分类
    entry(index) {
      this.hoverActive = index;
      this.RecommendExhibits = [];
      this.RecommendExhibits = this.dataSource[index].mining;
    },
    changeLang(e) {
      if (this.toggle == true) {
        // 当前显示的是中文图标,说明页面内容是英文,
        // todo: 把图标变为英文图标，内容变为中文
        this.toggle = false;
        localStorage.setItem('lang', 'zh');
        this.$i18n.locale = 'zh';
        this.lang = 'zh';
        // 存到localStorage的语言是zh
      } else if (this.toggle == false) {
        // 当前显示的是英文图标,说明页面内容是中文,
        // todo: 把图标变为中文图标，内容变为英文
        this.toggle = true;
        localStorage.setItem('lang', 'en');
        this.$i18n.locale = 'en';
        this.lang = 'en';
        // 存到localStorage的语言是en
      }
      window.location.reload();
    },

    handleCascader(value) {
      console.log(value);
    },

    searchClick() {
      const keyword = this.selectScreen[2];
      console.log('选择展商或展品的名字', this.selectScreen);
      if (this.select == 0) {
        //搜展品
        if (keyword == undefined) {
          const keyword = '';
          this.$router.push({
            name: 'exhibitsList',
            query: { exhibitsType: keyword, keyword: this.search },
          });
        } else {
          this.$router.push({
            name: 'exhibitsList',
            query: { exhibitsType: keyword, keyword: this.search },
          });
        }
      }

      if (this.select == 1) {
        //搜展商

        if (keyword == undefined) {
          // console.log('第一种方法');
          const keyword = 0;
          this.$router.push({
            name: 'exhibition',
            query: { exhibitsType: keyword, keyword: this.search },
          });
        } else {
          console.log('第二种方法');
          this.$router.push({
            name: 'exhibition',
            query: { exhibitsType: keyword, keyword: this.search },
          });
        }
      }
    },

    throttle(fn, delay) {
      var prev = Date.now();
      return function() {
        var now = Date.now();
        if (now - prev > delay) {
          fn();
          prev = Date.now();
        }
      };
    },
    windowScroll() {
      let scrollTop = null;
      let opacity = null;
      scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
      opacity = Math.abs(scrollTop / 570);
      // opacity = Math.abs(scrollTop / 4925);
      this.style = { background: `rgba(0, 111, 184,${opacity})` };
    },
    //获得通栏广告图
    async getbannerSlot() {
      try {
        const { data } = await getbannerSlot();
        this.Advertisement = forMat() + data.data;
      } catch (e) {
        console.log(e);
      }
    },
    getQueryString(query) {
      const obj = this.$router.history.current.query;
      if (obj[query]) {
        return obj[query];
      } else {
        return '';
      }
    },
    // 跳转逻辑
    switchRouter() {
      const token = this.getQueryString('token');
      const viewToken = this.getQueryString('viewToken');
      const redirectUrl = this.getQueryString('redirectUrl');
      if (viewToken) {
        // 说明是从观众个人后台登录跳转过来的
        localStorage.setItem('viewToken', viewToken);
        this.hasViewToken = true;
      }
      if (token) {
        localStorage.setItem('token', token);
        this.hasToken = true;
      }
      if (redirectUrl) {
        window.location.href = decodeURIComponent(redirectUrl);
      }
    },
  },

  created() {
    const href = window.location.href;
    this.switchRouter();

    const language = localStorage.getItem('lang');
    this.$i18n.locale = language == 'en' ? language : 'zh';
    this.lang = language == 'en' ? language : 'zh';
    this.toggle = language == 'en' ? true : false;

    if (language == 'en') {
      this.keywordsLists = productsEn;
    } else {
      this.keywordsLists = products;
      localStorage.setItem('lang', 'zh');
    }
    if (document.body.clientWidth <= 1680) {
      // 低分辨率
      this.isLowScreen = true;
    }
    this.holder = this.$t('homePage.handle.handle' + this.select);
    const zsToken = localStorage.getItem('token');
    if (zsToken) {
      this.hasToken = true;
    }
    const viewToken = localStorage.getItem('viewToken');
    if (viewToken) {
      this.hasViewToken = true;
    }
    if (href.includes('viewFlag')) {
      localStorage.removeItem('viewToken');
      if (localStorage.getItem('lang')) {
        localStorage.removeItem('lang');
        this.$i18n.locale = 'zh';
        this.lang = 'zh';
      }
      this.hasViewToken = false;
    }
    if (href.includes('zsFlag')) {
      localStorage.removeItem('token');
      if (localStorage.getItem('lang')) {
        localStorage.removeItem('lang');
        this.$i18n.locale = 'zh';
        this.lang = 'zh';
      }
      this.hasToken = false;
    }
    //引入通位广告图
    this.getbannerSlot();
    //引入商品分类，并为树状结构做处理
    // this.searchList = searchList;
    // this.addDisabledLable(this.searchList);
    // this.addtreeId(this.searchList);
    // this.treeData = this.searchList;
    // console.log(this.searchList);
    this.setrecommendExhibits();
    if (document.body.clientWidth <= 1680) {
      // 低分辨率
      this.isLowScreen = true;
    }
  },
  mounted() {
    window.addEventListener('scroll', this.throttle(this.windowScroll, 80));
  },
  destroyed() {
    console.log('销毁了');
    window.removeEventListener('scroll', this.throttle(this.windowScroll, 80));
  },
};
</script>
<style lang="scss" scoped>
.head {
  width: 100%;
  height: 100px;

  opacity: 1;
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 99;

  .header {
    width: 1270px;
    height: 100%;
    display: flex;
    align-items: center;

    margin: 0 auto;

    .left {
      display: none;
      justify-content: flex-start;
      align-items: center;

      .img {
        width: 550px;
        height: 86px;
      }

      .txt {
        width: 440px;
        margin-left: 15px;

        .p1 {
          display: block;
          font-size: 20px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #ffffff;
          line-height: 26px;
        }

        .p2 {
          display: block;
          font-size: 18px;
          font-family: Source Han Sans CN;
          font-weight: bold;
          color: #ffffff;
        }

        .p3 {
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 400;
          color: #ffffff;
        }
      }
    }

    .center {
      height: 100%;
      margin-left: 161px;
      position: relative;

      ul {
        height: 100%;
        list-style: none;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .hyperlinks {
          text-decoration: none;
          display: block;
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: center;
          margin-left: 36px;

          .li {
            position: relative;

            padding-bottom: 20px;
            position: relative;
            top: 10px;
            box-sizing: border-box;

            .menu {
              display: none;
              position: absolute;
              left: -18px;
              top: 40px;
              color: black;
              border-top: 3px solid #fdd000;
              box-shadow: 0px 0px 51px 0px #e8ecf0;
              width: fit-content;
              width: 105px;
              background-color: white;

              a {
                text-decoration: none;

                p {
                  height: 36px;
                  font-size: 16px;
                  font-family: Microsoft YaHei;
                  font-weight: 400;
                  color: #333333;
                  text-align: center;
                  line-height: 36px;

                  &:hover {
                    color: #006fb8;
                    background: #ededed;
                  }
                }
              }
            }

            &:hover {
              .menu {
                display: block;
              }
            }
          }
        }

        li {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #ffffff;
          // white-space: nowrap;
          // width: 30%;
        }

        li:hover {
          color: #fccf00;
        }
      }
    }

    .right {
      display: flex;
      align-items: center;
      justify-content: flex-start;
      margin-left: 26px;
      .login1 {
        // width: 101px;
        // padding: 0px 17px;
        // box-sizing: border-box;
        height: 39px;
        background: #fdd000;
        border-radius: 4px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #006fb8;
        text-align: center;
        cursor: pointer;
        line-height: 39px;
        margin-left: 1px;
        padding: 0px 10px;
        box-sizing: border-box;
      }
      .login1:hover {
        // width: 101px;
        // padding: 0px 17px;
        // box-sizing: border-box;
        height: 39px;
        background: #fdd933;
        border-radius: 4px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #006fb8;
        text-align: center;
        cursor: pointer;
        opacity: 0.9;
      }
      .login1:active {
        // width: 101px;
        // padding: 0px 17px;
        // box-sizing: border-box;
        height: 39px;
        background: #e4bb00;
        border-radius: 4px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #006fb8;
        text-align: center;
        cursor: pointer;
      }
      .login {
        height: 37px;
        border: 1px solid #ffffff;
        border-radius: 4px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        text-align: center;
        line-height: 37px;
        // width: 101px;
        // padding: 0px 17px;
        // box-sizing: border-box;
        height: 37px;
        margin-left: 4px;
        cursor: pointer;
      }
      .login:hover {
        // width: 101px;
        // padding: 0px 17px;
        // box-sizing: border-box;
        height: 37px;
        border: 1px solid #c4deef;
        border-radius: 4px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #e6f1f8;
      }
      .login:active {
        // width: 101px;
        // padding: 0px 17px;
        // box-sizing: border-box;
        height: 37px;
        border: 1px solid #ffffff;
        opacity: 0.7;
        border-radius: 4px;
        font-size: 16px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #fefefe;
        opacity: 0.7;
      }

      .language {
        font-size: 13px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #ffffff;
        display: flex;
        margin-left: 5px;

        .chese {
          margin-left: 9px;
          margin-right: 5px;
          padding-right: 5px;
          white-space: nowrap;
          cursor: pointer;
          img {
            vertical-align: middle;
            margin-right: 6px;
          }
        }

        .english {
          margin-left: 9px;
          margin-right: 5px;
          padding-right: 5px;
          white-space: nowrap;
          cursor: pointer;
          img {
            vertical-align: middle;
            margin-right: 6px;
          }
        }
      }
    }
  }
}

.bbody {
  background-image: url('../../static/IMG_exhibits.png');
  padding-bottom: 65px;
  .container {
    width: 1270px;
    min-width: 1270px;
    margin: 0 auto;

    .goldBox {
      position: relative;
      top: -65px;
      z-index: 20;

      .title {
        font-size: 30px;
        font-family: Microsoft YaHei;
        font-weight: 400;
        color: #333;
        text-align: center;
        background: #facd00;
        box-shadow: 0px 0px 51px 0px #e8ecf0;
        padding: 27px 0 25px 0px;
        box-sizing: border-box;
        z-index: 20;
        color: #006fb8;
      }

      //搜索框
      .search {
        padding: 0 80px;
        height: 50px;
        background: #facd00;
        display: flex;
        justify-content: flex-start;
        padding-bottom: 28px;

        //左侧的下拉框
        .selectBox {
          width: 154px;
          height: 50px;
          margin-right: 20px;

          .el-select-dropdown__item {
            font-size: 16px !important;
          }
        }

        //中间的属性下拉框
        .selecTree {
          width: 300px;
          height: 50px;
          margin-right: 20px;

          .el-select {
            width: 100%;
          }
          el-cascader{
            height: 500px !important;
          }
        }

        //右边的输入框以及按钮
        .searchBox {
          width: 521px;
          height: 50px;
          margin-right: 20px;
        }

        //右侧的蓝色按钮
        .btn {
          width: 131px;
          height: 50px;
          margin-right: 20px;

          .el-button {
            width: 100%;
            background: #006fb8;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #ffffff;

            .el-icon-search:before {
              font-size: 25px !important;
            }
          }
        }
      }
    }

    .recommended {
      font-size: 30px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      color: #333333;
      text-align: center;
      padding: 9px 0px 54px 0px;
    }

    .box {
      width: 100%;
      display: flex;
      justify-content: space-between;

      .left {
        width: 295px;

        .leftItem {
          width: 295px;
          height: 98px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          position: relative;
          color: #333333;
          background-color: white;
          transition: all 0.3s;

          border-top: 1px solid #e0e0e0;

          .img {
            width: 90px;
            height: 84px;
            display: flex;
            justify-content: center;
            align-items: center;
            margin-left: 38px;

            img {
              width: fit-content;
              height: fit-content;
              margin: 7px 13px 8px 7px;
              max-width: 69px;
              max-height: 70px;
            }
          }

          .titlee {
            margin-left: 23px;
            font-size: 18px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            width: 113px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            line-clamp: 2;
            -webkit-box-orient: vertical;
          }
        }
      }

      //left结束

      .right {
        flex: 1;
        box-sizing: border-box;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;

        .rightBox:hover {
          box-shadow: 2px 2px 10px #9fa3a5;
        }
        .rightBox {
          height: 480px;
          width: 294px;
          //height: fit-content;
          background-color: white;
          margin-left: 28px;
          margin-bottom: 28px;
          transition: all 0.3s;

          .parameter {
            height: 158px;
            padding-top: 35px;
            box-sizing: border-box;
            .titl {
              font-size: 24px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #333333;
              //margin-top: 35px;
              //margin-top: 23px;
              margin-left: 24px;
              max-width: 247px;
              overflow: hidden;
              text-overflow: ellipsis;
              display: -webkit-box;
              -webkit-box-orient: vertical;
              -webkit-line-clamp: 2;
              line-height: 28px;
              //height: 62px;
              word-break: break-all;
            }

            .english {
              font-size: 16px;
              line-height: 16px;
              font-family: Microsoft YaHei;
              font-weight: bold;
              color: #333333;
              margin-top: 15px;
              margin-left: 24px;
              max-width: 247px;
            }

            .txt {
              font-size: 14px;
              line-height: 14px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #999999;
              margin-top: 12px;
              margin-left: 24px;
              max-width: 247px;
            }
          }

          .backImg {
            width: 247px;
            height: 185px;
            justify-content: center;
            align-items: center;
            display: flex;
            //margin-top: 34px;
            //margin-top: 15px;

            img {
              max-width: 100%;
              max-height: 100%;
              vertical-align: middle;
            }
          }

          .companyName {
            margin: 19px 24px 20px 24px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            .leftTitle {
              font-size: 16px;
              font-family: Microsoft YaHei;
              font-weight: 400;
              color: #999999;
              max-width: 203px;
              text-overflow: ellipsis;
              white-space: nowrap;
              overflow: hidden;
            }

            // .rightIcon {
            //   width: 18px;
            //   height: 18px;
            //   margin-left: 6px;
            //   padding-bottom: 3px;

            //   img {
            //     width: 100%;
            //     height: 100%;
            //   }
            // }
            .rightIcon {
              display: block;
              position: relative;
              img {
                cursor: pointer;
              }
              .hoversty {
                width: 96px;
                height: 40px;
                background: #000000;
                opacity: 0.7;
                border-radius: 4px;
                cursor: pointer;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #ffffff;
                display: none;
                text-align: center;
                position: absolute;
                top: -8px;
                left: 25px;
                line-height: 40px;
              }
            }
            .rightIcon:hover .hoversty {
              display: block;
            }
          }
          .boxBottom {
            height: 68px;
            width: 295px;
            border-radius: 1px;
            border-top: 1px solid #e0e0e0;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .bottomTxt {
              margin-left: 24px;

              a {
                text-decoration: none;
                font-size: 16px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #333333;
              }
            }

            .bottomImg {
              width: 30px;
              height: 28px;
              margin-right: 24px;
              position: relative;
              img {
                width: 100%;
                height: 100%;
                cursor: pointer;
              }
              .hoversty {
                width: 96px;
                height: 40px;
                background: #000000;
                opacity: 0.7;
                border-radius: 4px;
                font-size: 14px;
                font-family: Microsoft YaHei;
                font-weight: 400;
                color: #ffffff;
                display: none;
                text-align: center;
                padding-top: 2px;
                position: absolute;
                top: -6px;
                left: 30px;
                line-height: 40px;
                cursor: pointer;
              }
            }
            .bottomImg:hover .hoversty {
              display: block;
            }
          }

          &:hover {
            .titl {
              color: #006fb8;
            }

            .english {
              color: #006fb8;
            }

            .boxBottom {
              .bottomTxt {
                a {
                  color: #006fb8;
                }
              }
            }
          }
        }
      }

      //right结束
    }

    a {
      display: block;
      text-decoration: none;

      .lookMore {
        width: 247px;
        height: 44px;
        border: 1px solid #333333;
        border-radius: 4px;
        margin: 0 auto;
        text-align: center;
        line-height: 44px;
        margin-top: 40px;
        color: #333333;
        font-size: 16px;
      }
    }
  }
}

.backImg {
  width: 100%;
  height: 320px;
  margin: 0 auto;

  img {
    width: 100%;
    height: 100%;
  }
}

// 超出长度文本省略
.ellipsis {
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}

@media only screen and (min-width: 1920px) {
  .head {
    width: 100%;

    .header {
      width: 1920px;
      box-sizing: border-box;

      .left {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin-left: 20px;

        .img {
          width: 550px;
          height: 86px;
        }

        .txt {
          width: 440px;
          margin-left: 15px;

          .p1 {
            display: block;
            font-size: 20px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #ffffff;
            line-height: 26px;
          }

          .p2 {
            display: block;
            font-size: 18px;
            font-family: Source Han Sans CN;
            font-weight: bold;
            color: #ffffff;
          }

          .p3 {
            font-size: d 16px;
            font-family: Source Han Sans CN;
            font-weight: 400;
            color: #ffffff;
          }
        }
      }
    }
  }
}

//----------------------快捷入口--------------------------
</style>
<style scoped>
.selectBox >>> .el-input__inner {
  height: 50px !important;
}

.el-button {
  height: 50px !important;
}

.tree .el-select-dropdown__item {
  padding: 0 !important;
}

.sel .el-select-dropdown__item {
  font-size: 16px !important;
}

.selectBox >>> .el-input__inner {
  /*color: red;*/
  font-size: 16px;
}

.selectBox >>> .el-select-dropdown__item {
  font-size: 16px !important;
}

.selecTree >>> .el-input__inner {
  /*color: red;*/
  height: 50px !important;
  font-size: 16px;
}
.selecTree >>> .el-scrollbar {
  /*color: red;*/
  height: 500px !important;
}
.selecTree >>> .el-tree-node__label {
  font-size: 16px !important;
}

.searchBox >>> .el-input__inner {
  /*color: red;*/
  font-size: 16px;
  height: 50px !important;
}

.selecTree >>> .el-select-dropdown__item {
  font-size: 16px !important;
}

.selectBox >>> .el-select-dropdown__item {
  font-size: 16px !important;
}

div /deep/ .el-tree__empty-text {
  font-size: 16px !important;
}

/* /deep/ .el-select-dropdown__item{
	font-size: 16px !important;
} */
/*>>>.el-popper .popper__arrow,*/
/*>>>.el-popper .popper__arrow::after{*/
/*  border-style: none !important;*/
/*}*/
/*>>>.el-popper {*/
/*  margin-top: 1px;*/
/*}*/
.el-cascader {
  width: 300px;
}
</style>
<style scoped>
.leftItem.active::before {
  background: #f4f4f4 !important;
  border-left: 5px solid gold;
  box-sizing: border-box;
  width: 4px;
  height: 98px;
  background-color: gold;
  content: '';
  position: absolute;
  top: 0px;
  left: 0px;
}

.leftItem.active {
  background: #f4f4f4 !important;
  color: #006fb8 !important;
}

/* >>> .el-tree-node__content .el-checkbox__input.is-disabled {
  display: none;
}

>>> .el-tree-node__content .is-leaf + .el-checkbox .el-checkbox__input {
  display: none;
}

>>> .el-tree-node__content .el-tree-node__label {
  user-select: none;
  font-size: 16px;
}

>>> .el-tree-node__content .el-icon-caret-right:before {
  content: none;
}
>>> .el-carousel__indicators.el-carousel__indicators--horizontal {
  bottom: 90px;
}
>>> .el-carousel__button {
  background: #ffffff !important;
} */
</style>
<style>
.sel .popper__arrow,
.sel .popper__arrow::after,
.tree .popper__arrow,
.tree .popper__arrow::after {
  border-style: none !important;
}
.sel.el-popper,
.tree.el-popper {
  margin-top: 2px;
  margin-bottom: 2px;
}
.el-cascader__dropdown, .el-cascader-panel, .el-scrollbar, .el-scrollbar__wrap {
  height: auto !important;
}
 .el-scrollbar__wrap {
  overflow: hidden !important;
}
</style>
